<template>
  <div class="impressao-impostos-coluna">
    <div class="separador"></div>
    <div
      v-if="montagemCheck.filter(p => p.ativo == true && this.exibe.includes(p.campo)).length"
      class="impressao-imposto selecionar-todos"
    >
      <input ref="checkTodos" type="checkbox" v-model="selecionaTodos" class="impressao-check" />
      <label @click="checkTodos">Selecionar Todos</label>
      <div :class="['impressao-check-custom', selecionaTodos ? 'impressao-check-bg' : '']">
        <p v-if="selecionaTodos">✓</p>
      </div>
    </div>
    <!-- <div
      v-if="montagemCheck.filter(p => p.ativo == true && this.exibe.includes(p.campo)).length"
      class="separador"
    ></div> -->
    <div class="impressao-imposto-container">
      <div
        v-if="exibe.includes(item.campo)"
        v-for="(item, index) in montagemCheck"
        :key="index"
        :class="[
          'impressao-imposto',
          'impressao-separador-coluna',
          item.ativo ? '' : 'impressao-imposto-desativado'
        ]"
      >
        <input
          :ref="`impressaoCheck${index}`"
          type="checkbox"
          :disabled="!item.ativo"
          v-model="item.model"
          class="impressao-check"
        />
        <label
          v-if="!item.ativo"
          v-b-tooltip.hover.right
          title="Selecione todas as opções nos resultados deste tributo"
          >{{ item.label }}</label
        >
        <label @click="selecionaTributo(index)" v-else>{{ item.label }}</label>
        <div
          :class="[
            'impressao-check-custom',
            !item.ativo ? 'impressao-check-disable' : '',
            item.model ? 'impressao-check-bg' : ''
          ]"
        >
          <p v-if="item.model">✓</p>
        </div>
      </div>
    </div>
    <div class="impressao-alerta"></div>
  </div>
</template>

<script>
export default {
  name: "ModalImpressaoCheck",
  props: {
    montagemCheck: Array | Object,
    exibe: Array | Object,
    todosImpostos: Function,
    resetModal: Function
  },
  data() {
    return {
      selecionaTodos: false
    };
  },
  watch: {
    montagemCheck: {
      deep: true,
      handler() {
        const montagemLen = this.montagemCheck.filter(p => p.model == true).length;
        const montagemAbLen = this.montagemCheck.filter(
          p => p.ativo == true && this.exibe.includes(p.campo)
        ).length;
        if (!(montagemAbLen == montagemLen)) {
          this.selecionaTodos = false;
        } else if (montagemAbLen == montagemLen) {
          this.selecionaTodos = true;
        }
      }
    },
    selecionaTodos() {
      const montagemLen = this.montagemCheck.filter(p => p.model == true).length;
      const montagemAbLen = this.montagemCheck.filter(
        p => p.ativo == true && this.exibe.includes(p.campo)
      ).length;
      if (this.selecionaTodos == true) {
        this.todosImpostos();
      } else if (montagemAbLen == montagemLen) {
        this.resetModal();
      }
    }
  },
  methods: {
    selecionaTributo(index) {
      let ref = this.$refs[`impressaoCheck${index}`];
      ref[0].click();
    },
    checkTodos() {
      let ref = this.$refs.checkTodos;
      ref.click();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/var.scss";

.impressao-impostos-coluna {
  display: flex;
  flex-direction: column;
  user-select: none;
  // margin: 5px 0;
  label {
    font-family: "Open Sans", sans-serif;
    font-size: 13px !important;
    line-height: 20px;
  }
}
.impressao-imposto {
  // cursor: pointer;
  display: flex;
  border: none;
  justify-content: flex-start;
  align-items: center;
  padding: 5px;
  height: 27px;
  label {
    cursor: pointer;
    // padding-top: 2px;
    margin: 0;
    padding: 0 5px;
    display: flex;
    font-size: 14px !important;
    font-family: "Roboto Condensed";
  }
}
.impressao-imposto-desativado {
  label {
    color: gray;
    text-decoration: line-through;
  }
}
.impressao-check-custom {
  position: absolute;
  z-index: -1;
  display: flex;
  justify-content: center;
  align-content: center;
  font-size: 15px;
  font-weight: bold;
  line-height: 16px;
  color: $corImpressaoCheck;
  border: 1px solid $bordaCinza;
  height: 20px;
  width: 20px;
  opacity: 1;
  border-radius: 3px;
  margin-bottom: 2px;
}
.impressao-check-bg {
  background: $corImpressaoCheckBg;
}
.impressao-check {
  cursor: pointer;
  width: 20px !important;
  height: 20px !important;
  opacity: 0;
}
.impressao-check-disable {
  color: $itemDesativado;
  background: var(--branco);
  border: 1px solid $itemDesativado;
}
.separador {
  width: 100%;
  border-bottom: 1px solid #9ea2a7;
}
.impressao-imposto-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
// .impressao-separador-coluna:nth-child(odd) {
//   border-right: 1px solid #9ea2a7;
// }
.selecionar-todos {
  margin-bottom: 15px;
}
</style>
